import AuthenticatedAPIClient from '../lib/AuthenticatedAPIClient';
import { URL } from '../helpers/CustomerEndpoint';
import UserStore from '../stores/UserStore';

const ConsentsService = {
    async getConsentsTemplate () {
        return AuthenticatedAPIClient.get(URL.consentsTemplate);
    },

    async getConsents () {
        const user = UserStore.getCurrent();
        const endpoint = URL.consents.replace('{id}', user.id);
        return AuthenticatedAPIClient.get(endpoint);
    },

    async updateConsents (payload) {
        const user = UserStore.getCurrent();
        const endpoint = URL.consents.replace('{id}', user.id);
        return AuthenticatedAPIClient.post(endpoint, payload);
    },

    // Short-lived DataGuard citizen token for the Manage widget, brokered by the backend.
    // `loader: false` keeps this background call from dispatching the global loading action:
    // the widget initialises from a mount effect that can fire while another Flux dispatch is
    // still in flight (notably a fresh-account SPA navigation to My Account), and a nested
    // dispatch throws "Cannot dispatch in the middle of a dispatch", aborting the token fetch
    // before it reaches the network and leaving the widget unrendered.
    async getManageWidgetToken () {
        const user = UserStore.getCurrent();
        const endpoint = URL.dataguardManageToken.replace('{id}', user.id);
        return AuthenticatedAPIClient.get(endpoint, {}, { loader: false });
    },
};

export default ConsentsService;
